export const Constants = {
  LEVELS: {
    ADMIN: 1,
    MODERATOR: 2,
    CLIENT: 3,
    RECEIVER: 4,
  },
  USER_STATUS: {
    ACTIVE: 1,
    INACTIVE: 0,
  },
  PACKAGE_STATUS: {
    PENDING: 0,
    FINISH: 1,
  },
  PHOTOS_STATUS: {
    PUBLISHED: 1,
    UNPUBLISHED: 0,
  },
  CHAT_STATUS: {
    ACTIVE: 1,
    INACTIVE: 0,
  },
};
